import { TemporalEntityId } from 'entities-next/common'
import React, { useRef } from 'react'
import { makeStyles } from 'tss-react/mui'
import { useMatchParams } from 'utils-next/routes'
import { Card, Divider, Theme } from '@mui/material'

import { ScoutingCampaignDetailsViewProvider } from './ScoutingCampaignDetailsView.store'
import { ScoutingCampaignDetailsViewContent } from './ScoutingCampaignDetailsViewContent.component'
import { ScoutingCampaignDetailsViewHeader } from './ScoutingCampaignDetailsViewHeader.component'

export function ScoutingCampaignDetailsView() {
  const { classes } = useStyles()
  const actionBarRef = useRef<any>(null)
  const { id } = useRouteVariables()
  return (
    <ScoutingCampaignDetailsViewProvider scoutingCampaignId={id} actionBarRef={actionBarRef}>
      <Card className={classes.content}>
        <ScoutingCampaignDetailsViewHeader className={classes.header} />
        <Divider />
        <ScoutingCampaignDetailsViewContent />
      </Card>
      <div className={classes.footer} ref={actionBarRef} />
    </ScoutingCampaignDetailsViewProvider>
  )
}

function useRouteVariables() {
  const { scoutingCampaignId = '' } = useMatchParams<{ scoutingCampaignId: string }>()
  const id = Number(scoutingCampaignId)
  if (isNaN(id)) {
    return {
      id: TemporalEntityId.new,
    }
  } else {
    return {
      id: id,
    }
  }
}

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  content: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    minHeight: spacing(50),
  },
  header: {
    position: 'relative',
    width: '100%',
    height: spacing(12),
  },
  footer: {
    position: 'relative',
    paddingTop: spacing(3),
    paddingBottom: spacing(2),
    width: '100%',
    bottom: 0,
    right: 0,
  },
}))
